export default {
  // —— Console/Admin OpenAPI ——
  'pages.openapi.overview.title': 'Visão geral da plataforma aberta',
  'pages.openapi.overview.loadFailed': 'Falha ao carregar o resumo de uso (a API pode ainda não estar pronta)',
  'pages.openapi.overview.docsTitle': 'Guia de integração',
  'pages.openapi.overview.docsDesc':
    'BasePath da plataforma aberta: /v1. Envelope de resposta: {code,message,data,request_id}. Para API Keys, envie Authorization: Bearer sk_live_... / sk_test_.... A chave em texto claro é exibida apenas uma vez na criação ou rotação—guarde-a com segurança.',
  'pages.openapi.overview.level': 'Nível atual',
  'pages.openapi.overview.qps': 'Limite de QPS',
  'pages.openapi.overview.apps': 'Apps',
  'pages.openapi.overview.appsSuffix': '(máx. {maxApps}, chaves por app {maxKeys})',
  'pages.openapi.status.active': 'Ativo',
  'pages.openapi.status.disabled': 'Desativado',
  'pages.openapi.apps.title': 'Apps e chaves',
  'pages.openapi.apps.listTitle': 'Meus apps',
  'pages.openapi.apps.create': 'Criar app',
  'pages.openapi.apps.createModal': 'Criar app',
  'pages.openapi.apps.name': 'Nome do app',
  'pages.openapi.apps.nameRequired': 'Informe um nome',
  'pages.openapi.apps.description': 'Descrição',
  'pages.openapi.apps.status': 'Status',
  'pages.openapi.apps.createdAt': 'Criado em',
  'pages.openapi.apps.createSuccess': 'App criado',
  'pages.openapi.apps.createFailed': 'Falha ao criar o app',
  'pages.openapi.apps.loadFailed': 'Falha ao carregar apps',
  'pages.openapi.apps.keysLoadFailed': 'Falha ao carregar chaves',
  'pages.openapi.apps.delete': 'Excluir',
  'pages.openapi.apps.deleteConfirm': 'Excluir este app?',
  'pages.openapi.apps.deleted': 'Excluído',
  'pages.openapi.apps.createKey': 'Criar Key',
  'pages.openapi.apps.createKeyModal': 'Criar API Key',
  'pages.openapi.apps.keyCreateSuccess': 'Chave criada',
  'pages.openapi.apps.keyCreateFailed': 'Falha ao criar a chave',
  'pages.openapi.apps.noPlainKey': 'Nenhuma chave em texto claro retornada',
  'pages.openapi.apps.plainKeyTitle': 'Salve sua API Key',
  'pages.openapi.apps.plainKeyHint': 'O texto claro é exibido apenas uma vez e não poderá ser visto novamente após fechar.',
  'pages.openapi.apps.copy': 'Copiar',
  'pages.openapi.apps.copied': 'Copiado',
  'pages.openapi.apps.copyFailed': 'Falha ao copiar; selecione manualmente',
  'pages.openapi.apps.close': 'Fechar',
  'pages.openapi.apps.key.name': 'Nome',
  'pages.openapi.apps.key.namePlaceholder': 'Chave principal de produção',
  'pages.openapi.apps.key.prefix': 'Prefixo',
  'pages.openapi.apps.key.env': 'Ambiente',
  'pages.openapi.apps.key.status': 'Status',
  'pages.openapi.apps.key.createdAt': 'Criado em',
  'pages.openapi.apps.key.disable': 'Desativar',
  'pages.openapi.apps.key.disableConfirm': 'Desativar esta chave?',
  'pages.openapi.apps.key.disabled': 'Desativada',
  'pages.openapi.apps.key.enable': 'Ativar',
  'pages.openapi.apps.key.enabled': 'Ativada',
  'pages.openapi.apps.key.rotate': 'Rotacionar',
  'pages.openapi.apps.key.rotateConfirm': 'A rotação gera uma nova chave e retorna o texto claro uma vez. Continuar?',
  'pages.openapi.apps.key.rotated': 'Rotacionada',
  'pages.openapi.apps.key.delete': 'Excluir',
  'pages.openapi.apps.key.deleteConfirm': 'Excluir esta chave? Não pode ser desfeito.',
  'pages.openapi.apps.key.deleted': 'Excluída',
  'pages.openapi.logs.title': 'Logs de uso',
  'pages.openapi.logs.listTitle': 'Detalhes das chamadas',
  'pages.openapi.logs.dailyTitle': 'Uso dos últimos 14 dias',
  'pages.openapi.logs.dailyEmpty': 'Sem dados de uso diário',
  'pages.openapi.logs.date': 'Data',
  'pages.openapi.logs.count': 'Chamadas',
  'pages.openapi.logs.createdAt': 'Hora',
  'pages.openapi.logs.requestId': 'Request ID',
  'pages.openapi.logs.requestIdPlaceholder': 'Cole o request_id da resposta da API',
  'pages.openapi.logs.detail': 'Detalhes',
  'pages.openapi.logs.detailTitle': 'Detalhes da chamada',
  'pages.openapi.logs.detailLoading': 'Carregando…',
  'pages.openapi.logs.requestQuery': 'Query',
  'pages.openapi.logs.requestBody': 'Requisição',
  'pages.openapi.logs.responseBody': 'Resposta',
  'pages.openapi.logs.app': 'App',
  'pages.openapi.logs.appId': 'ID do app',
  'pages.openapi.logs.apiKey': 'API Key',
  'pages.openapi.logs.userId': 'ID do usuário',
  'pages.openapi.logs.apiKeyId': 'Key ID',
  'pages.openapi.logs.keyPrefix': 'Prefixo Key',
  'pages.openapi.logs.method': 'Método',
  'pages.openapi.logs.path': 'Caminho',
  'pages.openapi.logs.statusCode': 'HTTP',
  'pages.openapi.logs.code': 'Código de negócio',
  'pages.openapi.logs.latency': 'Latência (ms)',
  'pages.openapi.logs.loadFailed': 'Falha ao carregar',
  'pages.openapi.planTiers.title': 'Planos da plataforma aberta',
  'pages.openapi.planTiers.level': 'Nível',
  'pages.openapi.planTiers.levelTip':
    'Plan tier level (1–5), aligned with the user profile Level. Higher numbers mean higher tiers.',
  'pages.openapi.planTiers.name': 'Nome',
  'pages.openapi.planTiers.qps': 'QPS',
  'pages.openapi.planTiers.qpsTip':
    'Max requests per second (Queries Per Second). Default rate limit for API Key calls on this tier: sustained rate equals this value; burst capacity is about QPS×2 (at least 5). Applies only to API Key calls; console/admin traffic is not counted. Individual keys may override. Exceeding the limit returns HTTP 429 (biz code 42901).',
  'pages.openapi.planTiers.dailyQuota': 'Cota diária',
  'pages.openapi.planTiers.dailyQuotaTip':
    'Max total API requests allowed per calendar day. Counted per user/key; only API Key calls count. Individual keys may override. Exceeding the limit returns HTTP 429 (biz code 42902).',
  'pages.openapi.planTiers.maxApps': 'Máx. de apps',
  'pages.openapi.planTiers.maxAppsTip':
    'Maximum number of OpenAPI apps a developer on this tier can create.',
  'pages.openapi.planTiers.maxKeys': 'Máx. de chaves por app',
  'pages.openapi.planTiers.maxKeysTip': 'Maximum number of API keys allowed under each app.',
  'pages.openapi.planTiers.allowedScopes': 'Allowed permissions (scopes)',
  'pages.openapi.planTiers.allowedScopesTip':
    'API permission scopes this tier may request or be granted. App and API Key scopes must be a subset of this selection.',
  'pages.openapi.planTiers.save': 'Salvar',
  'pages.openapi.planTiers.saved': 'Salvo',
  'pages.openapi.planTiers.saveFailed': 'Falha ao salvar',
  'pages.openapi.planTiers.loadFailed': 'Falha ao carregar planos',
  'pages.openapi.planTiers.readonly': 'Observadores têm acesso somente leitura e não podem editar planos',
  'pages.openapi.admin.usageLogsTitle': 'Auditoria de chamadas da plataforma aberta',
  'pages.openapi.admin.usageLogsList': 'Logs globais de chamadas',
  'pages.openapi.admin.disableKeyConfirm': 'Desativar esta API Key?',
  'pages.openapi.admin.disableKey': 'Desativar Key',
  'pages.openapi.admin.keyDisabled': 'Desativada',
  'pages.openapi.admin.appsTitle': 'Apps da plataforma aberta',
  'pages.openapi.admin.appsList': 'Todos os apps de desenvolvedor',
  'pages.openapi.admin.developers': 'Desenvolvedores',
  'pages.openapi.admin.apps': 'Apps',
  'pages.openapi.admin.keys': 'Total de chaves',
  'pages.openapi.admin.activeKeys': 'Chaves ativas',
  'pages.openapi.admin.todayRequests': 'Chamadas de hoje',
  'pages.openapi.admin.todayErrors': 'Erros de hoje',
  'pages.openapi.admin.errorCount': 'Erros',
  'pages.openapi.admin.owner': 'Proprietário',
  'pages.openapi.admin.keyCount': 'Chaves',
  'pages.openapi.admin.keyword': 'Palavra-chave',
  'pages.openapi.admin.keywordPlaceholder': 'Nome do app / descrição / código do locatário',
  'pages.openapi.admin.statsLoadFailed': 'Falha ao carregar estatísticas',
  'pages.openapi.admin.noKeys': 'Sem chaves',
  'pages.openapi.admin.appEnabled': 'App ativado',
  'pages.openapi.admin.appDisabled': 'App desativado',
  'pages.openapi.admin.appDisableConfirm': 'Desativar este app?',
  'pages.openapi.admin.appEnableConfirm': 'Ativar este app?',
  'pages.openapi.admin.keyEnableConfirm': 'Ativar esta chave?',
  'pages.admin.user.openapiDeveloperEnabled': 'Plataforma aberta',
  'pages.admin.user.openapi.on': 'Ativado',
  'pages.admin.user.openapi.off': 'Desativado',
  'pages.admin.user.openapiLevel': 'Nível da plataforma aberta',
  'pages.admin.user.openapiDeveloperEnabled.label': 'Ativar desenvolvedor',
  'pages.admin.user.openapiLevel.label': 'Nível',
  'pages.admin.user.openapiLevel.placeholder': '1-5',
  'pages.openapi.overview.dailyUsage': 'Uso de hoje',
  'pages.openapi.apps.key.enableConfirm': 'Ativar esta chave?',
  'pages.admin.user.section.openapi': 'Plataforma aberta',
};
